import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { confirmEmailVerification } from '../api/auth'
import { useAuthStore } from '../store/auth'

export function VerifyEmail() {
  const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying')
  const [errorMessage, setErrorMessage] = useState('')
  const setEmailVerified = useAuthStore((s) => s.setEmailVerified)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    if (!token) {
      setErrorMessage('no verification token found in the url')
      setStatus('error')
      return
    }
    confirmEmailVerification(token)
      .then(() => { setStatus('success'); setEmailVerified(true) })
      .catch((err) => {
        setErrorMessage(err instanceof Error ? err.message : 'verification failed')
        setStatus('error')
      })
  }, [setEmailVerified])

  return (
    <div style={{ padding: '2rem', maxWidth: 480 }}>
      <h2>email verification</h2>
      {status === 'verifying' && <p>verifying…</p>}
      {status === 'success' && (
        <>
          <p>your email address has been verified.</p>
          <p><Link to="/settings">back to settings</Link></p>
        </>
      )}
      {status === 'error' && (
        <>
          <p style={{ color: 'var(--color-1)' }}>{errorMessage}</p>
          <p><Link to="/settings">back to settings</Link></p>
        </>
      )}
    </div>
  )
}
